import { SDUIOnClickHandler } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIImageOrIconRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/ImageOrIcon/SDUIImageOrIconRenderer";
import { SDUITileInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { SDUITypographyRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { ColorTokenKey } from "@faire/web-api--source/indigofair/data/ColorTokenKey";
import { Pill } from "@faire/web/slate-deprecated/Filter/styled";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const SDUIPillTileRenderer = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { title, subtitle, decoration, style } = tileElement.pill_tile ?? {};
  if (!title && !subtitle && !decoration) {
    return null;
  }

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
    >
      <Pill
        className="bg-core-surface-subdued w-fit pr-6 whitespace-nowrap"
        style={getBackground(style?.background_color)}
      >
        {decoration ? (
          <SDUIImageOrIconRenderer imageOrIcon={decoration} className="mr-4" />
        ) : null}
        <Spacer width="2x" />
        <Column>
          {title ? (
            <SDUITypographyRenderer
              textElement={title}
              loggingData={loggingData}
            />
          ) : null}
          {subtitle ? (
            <SDUITypographyRenderer
              textElement={subtitle}
              loggingData={loggingData}
            />
          ) : null}
        </Column>
      </Pill>
    </SDUIOnClickHandler>
  );
};

const getBackground = (
  overrideBackgroundColor: keyof typeof ColorTokenKey | undefined
) => {
  if (overrideBackgroundColor === null) {
    return { backgroundColor: "transparent" };
  } else if (overrideBackgroundColor) {
    return {
      backgroundColor: getSlateColorToken(overrideBackgroundColor),
    };
  } else {
    return undefined;
  }
};
